var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeTopRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 352,
    viewBox: "0 0 352 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1841_7596",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 352,
    height: 352
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 352,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1841_7596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.719 210.295L305.213 91.8005L305.213 339.121C305.213 349.433 317.668 354.589 324.957 347.3L467.99 204.268C476.668 195.589 476.668 181.52 467.99 172.842L186.719 -108.43C176.152 -118.996 159.03 -118.996 148.463 -108.43L8.2291 31.8048C-2.33763 42.3716 -2.33763 59.4936 8.22911 70.0603L148.463 210.295C159.03 220.861 176.152 220.861 186.719 210.295Z",
    fill: "#FFF6CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.111 92.3079L319.111 91.1008L318.258 91.9544L201.056 209.156C190.8 219.412 174.181 219.412 163.925 209.156L25.2198 70.4513C14.9636 60.1951 14.9636 43.5764 25.2198 33.3202L163.925 -105.385C174.181 -115.641 190.8 -115.641 201.056 -105.385L479.259 172.819C487.647 181.207 487.647 194.807 479.259 203.195L337.786 344.668C330.892 351.562 319.111 346.685 319.111 336.931L319.111 92.3079Z",
    stroke: "#6DDFA6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeTopRight);
export default __webpack_public_path__ + "static/media/shape-top-right.1576831813f9595a964219a5dd42653c.svg";
export { ForwardRef as ReactComponent };